import { ListConfigurationCacheService } from '../list-builder/services/ListConfigurationCacheService';
import { ListNavigationService } from '../services/ListNavigationService';
import { clearAllWorkdStorage } from '../storage/workdStorage';
import { useAnnouncementsStore } from './announcementsStore';
import { useAuthStore } from './authStore';
import { useDynamicViewStore } from './dynamicViewStore';
import { useListStore } from './listStore';
import { usePreferencesStore } from './preferencesStore';

// Re-export all stores
export { useAuthStore } from './authStore';
export type {
	AuthInstance,
	AuthStoreActions,
	AuthStoreState,
	AuthUser,
} from './authStore';

export { useListStore } from './listStore';
export type {
	CachedCount,
	CachedCounts,
	FailedListEntry,
	ListNavigationContext,
	ListPreferences,
	ListSessionNavigationState,
	ListSortField,
	ListStoreActions,
	ListStoreState,
} from './listStore';

export { usePreferencesStore } from './preferencesStore';
export type {
	PreferencesStoreActions,
	PreferencesStoreState,
	RingCentralPreferences,
} from './preferencesStore';

export {
	isInAppComposeAvailable,
	openInAppCompose,
	useComposeEmailBridge,
} from './composeEmailBridge';
export type { ComposeEmailOptions } from './composeEmailBridge';

export { useAnnouncementsStore } from './announcementsStore';
export type {
	AnnouncementsStoreActions,
	AnnouncementsStoreState,
	CachedAnnouncements,
} from './announcementsStore';

export { useDynamicViewStore } from './dynamicViewStore';
export type {
	DynamicViewStoreActions,
	DynamicViewStoreState,
} from './dynamicViewStore';

/**
 * Clear all Zustand stores and workd: prefixed storage.
 * This is the primary cleanup function called on logout.
 *
 * Clears:
 * - Auth store (tokens, user, instance, OAuth state)
 * - List store (counts, preferences, navigation state, filter state)
 * - Preferences store (language, theme, RingCentral, config-web settings)
 * - Announcements store (dismissed IDs, cached announcements)
 * - In-memory caches (ListConfigurationCacheService)
 * - All workd: prefixed localStorage keys
 * - All workd: prefixed sessionStorage keys
 */
export function clearAllStores(): void {
	console.debug('[stores] clearAllStores - CLEARING ALL STORES');
	console.trace('[stores] clearAllStores - stack trace');

	// Clear all Zustand stores
	useAuthStore.getState().clearAuth();
	useListStore.getState().clearAll();
	usePreferencesStore.getState().clearAll();
	useAnnouncementsStore.getState().clearAll();
	useDynamicViewStore.getState().clearView();

	// Clear in-memory caches that are tenant-specific
	ListConfigurationCacheService.clear();
	ListNavigationService.clearAllNavigationWindows();

	// Clear all workd: prefixed storage (localStorage + sessionStorage)
	clearAllWorkdStorage();
}
